import { Controller } from "@hotwired/stimulus"

// Keyboard shortcuts + cover preview for the Review Wizard.
//   D = submit "Save & Mark Done"
//   S = skip
// Disabled when focus is in an input/textarea/select so typing in fields stays
// natural.
export default class extends Controller {
  static targets = ["doneButton", "skipForm"]

  connect() {
    this.boundKeyHandler = this.handleKey.bind(this)
    document.addEventListener("keydown", this.boundKeyHandler)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundKeyHandler)
  }

  handleKey(event) {
    // Ignore shortcuts while typing in form fields
    const tag = (event.target.tagName || "").toLowerCase()
    if (["input", "textarea", "select"].includes(tag) || event.target.isContentEditable) return
    if (event.metaKey || event.ctrlKey || event.altKey) return

    const key = event.key.toLowerCase()
    if (key === "d" && this.hasDoneButtonTarget) {
      event.preventDefault()
      this.doneButtonTarget.click()
    } else if (key === "s" && this.hasSkipFormTarget) {
      event.preventDefault()
      // skipForm is the button_to-generated form's button
      this.skipFormTarget.click()
    }
  }

  // Live-update the cover preview as the user pastes a new image URL.
  updatePreview(event) {
    const url = event.target.value.trim()
    const img = document.getElementById("cover-preview")
    if (img && url) img.src = url
  }
}
